import axios from "axios";
import React, {useEffect, useState} from "react";
import {Container, Row, Col} from "react-bootstrap";
import {useNavigate, useParams} from "react-router-dom";
import Footer from "./Footer";
import GoUpButton from "./GoUpButton";
import HeaderWrapper from "./HeaderWrapper";
import LeftSideBarWrapper from "./LeftSideBarWrapper";
//import DOMPurify from "dompurify";
import AccordContent from "./Content/acord";
import FlipCardWrapper from "./FlipCard/FlipCardWrapper";

const API_URL = process.env.REACT_APP_API_URL;

interface carreraProps {
    titulo: string;
    descripcion: string;
    imagen: string;
    tsu: string;
    perfil: string;
    perfil_egreso: string;
    mision: string;
    vision: string;
    cuerpo: string;
    ventajas: string;
    contacto: string;
    atributos: string;
    objetivos: string;
    id_enlace: string;
    tipo: string;
}

const IncubadoraPage: React.FC = () => {
    const {url} = useParams();
    const [sidebarMenuItems, setSidebarMenuItems] = useState<any[]>([]);
    //const [infoCarrera, setInforCarrera] = useState<any>()
    const [info, setInfo] = useState<carreraProps>();
    //const [sideBarTitle, setSideBarTitle] = useState("")
    const navigate = useNavigate()

    /*     const sanitizeHtml = (html: string) => ({
            __html: DOMPurify.sanitize(html),
        }); */

    const getChilds = async () => {
        try {
            const response = await axios.get(`${API_URL}/enlaces/getChildrenIncubadora`
            )
            const items = response.data
            setSidebarMenuItems(items)
        } catch (error) {
            console.log('Error: ', error)
        }
    }

    const getInfo = async () => {
        try {
            const response = await axios.get(`${API_URL}/enlaces/getChildrenIncubadora`)
            const items = response.data;
            setInfo(items);
            setSidebarMenuItems(items)
        } catch (error) {
            //console.log('Error: ', error)
            navigate('/404');
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            await getInfo();
        };
        fetchData();
    }, [url]);

    return (
        <>
            <HeaderWrapper/>
            <Container fluid>
                <Row>
                    <>
                        <Col className='menuBox' md={3}>
                            <LeftSideBarWrapper tipo="" items={sidebarMenuItems}
                                                titulo="Incubadora"/>
                        </Col>
                        <Col className='content-wrapper ps-5' md={6} tabIndex={0}>
                            {sidebarMenuItems.map((ite: any, index: number) => {
                                    switch (ite.tipo) {
                                        case "info":
                                            return <div key={index} id={ite.url}>
                                                <Row id={ite.url}>
                                                    <h2 className="pb-3">{ite.titulo}</h2>
                                                    <div dangerouslySetInnerHTML={{__html: ite.cuerpo}}/>

                                                </Row>
                                                <div className='mb-5 pb-5 mt-5 pt-5'>
                                                    <hr style={{width: '60%'}}/>
                                                </div>
                                            </div>
                                        case "acord":
                                            return <div key={index} id={ite.url}><AccordContent url={ite.url}
                                                                                                id_enlace={ite.id_enlace}
                                                                                                titulo={ite.titulo}/>
                                                <div className='mb-5 pb-5 mt-5 pt-5'>
                                                    <hr style={{width: '60%'}}/>
                                                </div>
                                            </div>
                                        case "titulo_perfil":
                                            return (ite.tipo === "acord") ?
                                                <div key={index} id={ite.url}><AccordContent url={ite.url}
                                                                                             id_enlace={ite.id_enlace}
                                                                                             titulo={ite.titulo}/>
                                                    <div className='mb-5 pb-5 mt-5 pt-5'>
                                                        <hr style={{width: '60%'}}/>
                                                    </div>
                                                </div>
                                                :
                                                <Row key={index} id={ite.url}>
                                                    <h2 className="pb-3">{ite.titulo}</h2>
                                                    <FlipCardWrapper url={url} id_enlace={ite.id_enlace}/>
                                                    <div className='mb-5 pb-5 mt-5 pt-5'>
                                                        <hr style={{width: '60%'}}/>
                                                    </div>
                                                </Row>
                                        default:
                                            <></>
                                    }
                                }
                            )}
                        </Col>
                        <Col md={3} className='rightSideBar'></Col>
                        <GoUpButton/>
                    </>
                </Row>
            </Container>
            <Footer/>
        </>
    )
}

export default IncubadoraPage;